import React, { useEffect, useState, useContext, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { timesheetuserService } from '../services/timesheetUserservice';
import { userService } from '../services/authentication';
import { FaBeer, FaCheck, FaEdit, FaRecycle, FaSearch } from "react-icons/fa";
import { MdOutlineCancel, MdOutlineClear } from "react-icons/md";
import { loader } from '../compnents/loadermd';
import PaginationExample from '../compnents/pagination';
import { Dialog } from 'primereact/dialog';
import { Paginator } from 'primereact/paginator';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { formatterhelper } from '../helpers/dateformatter';
import { ToggleButton } from 'primereact/togglebutton';


const Users = () => {

  const toast = useRef(null);
  const toastTopCenter = useRef(null);
  const [formData, setFormData] = useState({
    client: '',
    subclient: '',
    BilledMinutes: '',
    Count: '',
    Minutes: '',
    Remarks: '',
    Task: '',
    budget_hours: '',
    date: 0,
    querycount: '',
    remaining_hrs: ''
  });

  const [formdata2, setForm2Data] = useState({ "employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": "0", "approver": "", "role": "" });
  const [formdataedit, setFormDataedit] = useState({ "id":"","employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": '0', "approver": "", "role": "","status":'' });

  const [users, setUsers] = useState([]);
  const [isloaded, setLoading] = useState(true);
  const [isdialog, setuserdialog] = useState(false);
  const [isdialogedit, setusereditdialog] = useState(false);
  const [totalpages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [last_page, setLastpage] = useState(1);
  const [per_page, setperpage] = useState(0);

  const [deptcomp, setdeptcomp] = useState([]);
  const [rolecomp, setrolecomp] = useState([]);
  const [teamcomp, setteamcomp] = useState([]);
  const [projectcomp, setprojectcomp] = useState([]);
  const [userscomp, setuserscomp] = useState([]);
  const [costcentercomp, setcostcomp] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};

  const [newErrors, setErrors] = useState({'adduser' : { "employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": "", "approver": "", "role": "" },
  'edituser' : { "employeeid": "", "userid": "", "name": "", "date_of_joining": "", "date_of_handovers": "", "project_name": "", "departmentname": "", "roletype": "", "project": "", "costcenter": "", "isadder": "", "approver": "", "role": "" }
});
  const [iseditsubmitted, setEditsubmitted] = useState(false);

  useEffect(() => {
    getUsers();
    getdependencies();
  }, [iseditsubmitted]);


  function isverfiedCom({ status }) {
    let comp = null;
    switch (status) {
      case 1:
        comp = (<FaCheck />)
        break;
      default:
        comp = (<MdOutlineClear />)
    }
    return comp;
  }


  const getUsers = (pageno) => {
    try {
      setLoading(false);
      let emparra = [];
      let emppages = [];
      timesheetuserService.getusers(pageno).then((response) => {
        response.data.data.data.forEach((value, index) => {
          emparra.push((
            <tr key={index}>
              <td>{value.id}</td>
              <td>{value.name}</td>
              <td>{value.project}</td>
              <td>{value.role}</td>
              <td>{value.verified_on}</td>
              <td>{isverfiedCom({ status: value.status })}</td>
              <td><FaRecycle className='custom-cursor-style' onClick={()=>resetpass(value)} /></td>
              <td><FaEdit className='custom-cursor-style' onClick={() => edittoggle({ data: value })} /></td>
            </tr>
          ));
        });
        //  console.log('response data');
        //  console.log(response.data.data.total);
        for (let i = 0; i < response.data.data.total; i++) {
          emppages.push(i);
        }
        setLoading(true);
        setUsers(emparra);
        setPages(emppages);
        setCurrentPage(response.data.data.current_page);
        setLastpage(response.data.data.last_page);
        setperpage(response.data.data.per_page);
      }).catch((error) => {
        setLoading(true);
        console.log(error);
      });
    } catch (error) {
      console.log(error);
    }
    // console.log(pageno);
  }

  const edittoggle = ({ data }) => {
    data.departmentname = data.dept;
    setFormDataedit(data);
    setusereditdialog(true);
  };


  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    let pageno = 1;
    if (event.first == 0) {
      pageno = 1;
    } else {
      pageno = ((event.first / rows) + 1);
    }

    if (searchQuery.trim().length > 0) {
      searchusersbyquery({ query: searchQuery, pageno });
    } else {
      getUsers(pageno);
    }
    // console.log(pageno);
  };

  const resetpass = (objdata) => {
    // console.log("reset pass");
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Password Reset Confirmation',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: () => resetpass_({objdata}),
     //  accept,
      reject
   });
  }

  const reject = () => {
    toast.current.show({ severity: 'warn', summary: 'Password Reset', detail: 'Canceled', life: 3000 });
  }

  const resetpass_ = ({objdata}) =>{
    try{
      userService.resetpassword(objdata).then((response)=>{
        if(response.status == 200){
          // toastTopCenter.current.show({ severity: 'success', summary: 'Password Reset', detail: response.data.data, life: 3000 });
        }else{
          // toast.current.show({ severity: 'error', summary: 'Password Reset', detail: 'Not reset', life: 4000 });
        } 
      }).catch((error)=>{
          // console.log(error);
          // toast.current.show({ severity: 'error', summary: 'Password Reset', detail: 'Somthing went wrong', life: 3000 });
      });
    }catch(error){
      //  console.log(error);   
    }
  }

  const validateForm = ({formdata,type}) => {
    let valid = true;
    const newErrors = {};
    if (formdata.userid == '') {
      newErrors.userid = 'UserId is required';
      valid = false;
    }
    if (formdata.name == '') {
      newErrors.name = 'Name is required';
      valid = false;
    }

    // if (formdata.date_of_joining == '') {
    //   newErrors.date_of_joining = 'Date of joining is required';
    //   valid = false;
    // }

    if (formdata.project == '') {
      newErrors.project = 'Project is required';
      valid = false;
    }

    if (formdata.project_name == '') {
      newErrors.project_name = 'Project name is required';
      valid = false;
    }
    if (formdata.departmentname == '') {
      newErrors.departmentname = 'Department is required';
      valid = false;
    }

    if (formdata.roletype == '') {
      newErrors.roletype = 'Role type is required';
      valid = false;
    }

    if (formdata.costcenter == '') {
      newErrors.costcenter = 'Costcenter is required';
      valid = false;
    }

    if (formdata.approver == '') {
      newErrors.approver = 'Approver is required';
      valid = false;
    }

    if (formdata.role == '') {
      newErrors.role = 'User type is required';
      valid = false;
    }


    if (formdata.employeeid == '') {
      newErrors.employeeid = 'Employee is required';
      valid = false;
    }

    if (formdata.teamname == '') {
      newErrors.teamname = 'Teamname is required';
      valid = false;
    }


    // if (formdata.isadder == '') {
    //   newErrors.isadder = 'Isaddar is required';
    //   valid = false;
    // }
    
    if(type == 'add'){
        setErrors((prevData) => ({...prevData,adduser:newErrors}));     
    }else {
      // return;
      setErrors((prevData) => ({...prevData,edituser:newErrors}));  
    }
    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm2Data((prevData) => ({
      ...prevData,
      [name]: value,
    }));

   
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm({formdata:formdata2,type:'add'})) {
      adduser({ obj: formdata2 });
    }
  };
  function adduser({ obj }) {
    obj = JSON.stringify(obj);
    timesheetuserService.addUser({ formdata: obj }).then((response) => {
      // console.log(response);
      if (response.status == 200) {
        toast.current.show({ severity: 'success', summary: "User", detail: `User added successfully!`, life: 3000 });
        setuserdialog(false);
      } else if (response.status == 400) {
        toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 });
      }
      else {
        toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 });
      }
    });
  }

  const edithandleChange = (e) => {
    const { name, value } = e.target;
    setFormDataedit((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const edithandleSubmit = (e) => {
    e.preventDefault();
    // console.log(formdataedit);
    if (!validateForm({formdata:formdataedit,type:'edit'})) {
          return;      
    }
    
   
    let strobj = JSON.stringify(formdataedit);
    timesheetuserService.updateusr({formdata:strobj}).then((response)=>{
       console.log(response);
       if(response.status == 200){
          toast.current.show({ severity: 'success', summary: "User", detail: `Updated successfully!`, life: 3000 });   
          getUsers(1);
          setusereditdialog(false);
       }else{
          toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 }); 
          
       }  
    }).catch((error)=>{
       console.log(error);
       toast.current.show({ severity: 'error', summary: "User", detail: `Error`, life: 3000 });
       setusereditdialog(false);
    });
    
    // console.log(formdataedit);
  }

  

  function updateuserstatus(e,id){
      
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'User Account Activation',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: () => {
        let obj = {
          'id':id,
          'status':e.value ? 1 : 0
        }
        obj = JSON.stringify(obj);
        timesheetuserService.updateuserstatus({formdata:obj}).then((response)=>{
          if(response.status == 200){
              toast.current.show({ severity: 'success', summary: "User", detail: `${response.data.data}`, life: 3000 });  
              getUsers(1);
              setusereditdialog(false); 
          }else{
              toast.current.show({ severity: 'error', summary: "User", detail: `${response.data.data}`, life: 3000 }); 
          }   
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: "User", detail: `Error`, life: 3000 }); 
            setusereditdialog(false); 
        });
      },
     //  accept,
      reject : ()=> {
        toast.current.show({ severity: 'warn', summary: 'User account activation', detail: 'Canceled', life: 3000 });
      }
   }); 
  }


  function getdependencies() {
    try {
      let depttemp = [];
      let teamtemp = [];
      let roletemp = [];
      let projecttemp = [];
      let usertemp = [];
      let costcentertemp = [];

      timesheetuserService.getdept().then((response) => {
        try {
          if (response != undefined && response.data != undefined) {
            response.data.data.forEach((value, item) => {
              depttemp.push(<option value={value.dept_name}>{value.dept_name}</option>);
            });
            setdeptcomp(depttemp);
          }
        } catch (error) {
          console.log(error);
        }

      });

      timesheetuserService.getteam().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            teamtemp.push(<option value={value.team_name}>{value.team_name}</option>);
          });
          setteamcomp(teamtemp);
        }
      });

      timesheetuserService.getrole().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            if(userdata.id != 1){
                if(value.rolename != 'admin'){
                    roletemp.push(<option value={value.rolename}>{value.rolename}</option>);
                }
               
            }else{
                roletemp.push(<option value={value.rolename}>{value.rolename}</option>);
            }
          });
          setrolecomp(roletemp);
        }
      });


      timesheetuserService.getproject().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            projecttemp.push(<option value={value.name}>{value.name}</option>);
          });
          setprojectcomp(projecttemp);
        }
      });

      timesheetuserService.getApprover().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            usertemp.push(<option value={value.id}>{value.name}</option>);
          });
          setuserscomp(usertemp);
        }
      });

      timesheetuserService.getcostcenter().then((response) => {
        if (response != undefined && response.data != undefined) {
          response.data.data.forEach((value, item) => {
            costcentertemp.push(<option value={value.id}>{value.costcentername}</option>);
          });
          setcostcomp(costcentertemp);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  const searchusersbyquery = ({ query, pageno }) => {
    let emparra = [];
    let emppages = [];
    timesheetuserService.searchusers({ searchq: query, pageno }).then((response) => {
      response.data.data.data.forEach((value, index) => {
        emparra.push((
          <tr key={index}>
            <td>{value.id}</td>
            <td>{value.name}</td>
            <td>{value.project}</td>
            <td>{value.role}</td>
            <td>{value.verified_on}</td>
            <td>{isverfiedCom({ status: value.status })}</td>
            <td><FaRecycle className='custom-cursor-style' onClick={()=>resetpass(value)} /></td>
            <td><FaEdit className='custom-cursor-style' onClick={() => edittoggle({ data: value })} /></td>
          </tr>
        ));
      });
      for (let i = 0; i < response.data.data.total; i++) {
        emppages.push(i);
      }
      setLoading(true);
      setUsers(emparra);
      setPages(emppages);
      setCurrentPage(response.data.data.current_page);
      setLastpage(response.data.data.last_page);
      setperpage(response.data.data.per_page);
    }).catch((error) => {
      setLoading(true);
      console.log(error);
    });
  };

  const onSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (value.trim().length < 1) {
      setFirst(0);
      getUsers(1);
    }
  };

  function searchusers(event){
     if (event.key === 'Enter') {
      setFirst(0);
      searchusersbyquery({ query: event.target.value, pageno: 1 });
    }
  }

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Toast ref={toastTopCenter} position="top-center" />
      <div className="invisible-divider-sm"></div>

      <h6>Users</h6>
      <div className='card card-custom-style card-style-padding'>
        <div className="row">
          <div className="col-md-2">
            <Button className='custom-btn-style pull-left search-box-height' onClick={() => setuserdialog(true)}>Add User</Button>
          </div>
          <div className="col-md-10">
            <span className="p-input-icon-left pull-right">
              {/* <i className="pi pi-search" /> */}
              <FaSearch />
              <InputText className="search-box-height" placeholder="Press and Enter" value={searchQuery} onChange={onSearchChange} onKeyDown={(e)=>{searchusers(e)}}/>
            </span>
          </div>
        </div>

      </div>
      <div className="invisible-divider-sm"></div>
      <div className='card card-custom-style card-style-padding'>
        <div className='row'>
          <div className='col-md-4'></div>
          <div className='pagination col-md-8'>
            {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
            {isloaded ? (<Paginator first={first} rows={rows} totalRecords={totalpages.length} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
          </div>
        </div>
        <div className="row">
          <Dialog header="Add User" visible={isdialog} style={{ width: '80%' }} onHide={() => setuserdialog(false)}>
            <form onSubmit={handleSubmit}>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <label>User Id Or Email address <span className='error'>*</span></label>
                    <input type='text' name='userid' required value={formdata2.userid} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.userid}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Name <span className='error'>*</span></label>
                    <input type='text' required name='name' value={formdata2.name} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.name}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Date of Joining <span className='error'>*</span></label>
                    <br />
                    <Calendar
                      className='calender-custom-style'
                      name="date_of_joining" required value={formdata2.date_of_joining} onChange={(e) => handleChange(e)} style={{ width: '100%' }} />
                    <span className='error'>{newErrors.adduser.date_of_joining}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Date of Handover to Operations</label>

                    <Calendar className='calender-custom-style'
                      name="date_of_handovers" value={formdata2.date_of_handovers} onChange={(e) => handleChange(e)} style={{ width: '100%' }} />
                  </div>

                  <div className='col-md-6'>
                    <br />
                    <label>Name of the Project <span className='error'>*</span></label>
                    <br />
                    <input type='text' required name='project_name' value={formdata2.project_name} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.project_name}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Department Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="departmentname" value={formdata2.departmentname} onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {deptcomp}
                    </select>
                    <span className='error'>{newErrors.adduser.departmentname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Team Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="teamname" value={formdata2.teamname} onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {teamcomp}
                    </select>
                    <span className='error'>{newErrors.adduser.teamname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Role <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="roletype" value={formdata2.roletype} onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {rolecomp}
                    </select>
                    <span className='error'>{newErrors.adduser.roletype}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>User Type <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="role" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      <option value="UL1">Manager</option>
                      <option value="CL1">Normal User</option>
                    </select>
                    <span className='error'>{newErrors.adduser.role}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>project <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="project" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {projectcomp}
                    </select>
                    <span className='error'>{newErrors.adduser.project}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Aprover <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="approver" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {userscomp}
                    </select>
                    <span className='error'>{newErrors.adduser.approver}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Cost Center <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="costcenter" onChange={(e) => handleChange(e)}>
                      <option value="">Select</option>
                      {costcentercomp}
                    </select>
                    <span className='error'>{newErrors.adduser.costcenter}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Employee ID <span className='error'>*</span></label>
                    <br />
                    <input type='number' required name='employeeid' value={formdata2.employeeid} class="form-control" onChange={(e) => handleChange(e)} />
                    <span className='error'>{newErrors.adduser.employeeid}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Add Permission <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="isadder" value={formdata2.isadder} onChange={(e) => handleChange(e)}>
                      <option value="">Select </option>
                      <option value="1">Enabled</option>
                      <option value="0">Disabled</option>
                    </select>
                    <span className='error'>{newErrors.adduser.isadder}</span>
                  </div>
                </div>
                <br />
                <br />

                <div className='row'>
                  <div>
                    <div className='pull-right'>
                      <span>
                        <Button type="submit" label="Save" icon="pi pi-check" severity="success" rounded />
                      </span>

                      <span>
                        <Button type="button" label="Close" severity="danger" onClick={() => setuserdialog(false)} rounded />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Dialog>

          <Dialog header="Edit User" visible={isdialogedit} style={{ width: '80%' }} onHide={() => setusereditdialog(false)}>
            <form onSubmit={edithandleSubmit}>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <label>User Id Or Email address <span className='error'>*</span></label>
                    <input type='text' required name='userid' value={formdataedit.userid} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.userid}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Name <span className='error'>*</span></label>
                    <input type='text' required name='name' value={formdataedit.name} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.name}</span>
                  </div>
                  <div className='col-md-4'>
                    <label>Date of Joining <span className='error'>*</span></label>
                    <br />
                    <input type="date" required className='custom-calender-style calender-custom-style'
                      name="date_of_joining" dateFormat='yy/mm/dd' value={formdataedit.date_of_joining} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }} />
                    {/* <Calendar
                      className='calender-custom-style'
                      name="date_of_joining" dateFormat='yy/mm/dd' value={formdataedit.date_of_joining} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }} /> */}
                      <span className='error'>{newErrors.edituser.date_of_joining}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Date of Handover to Operations</label>
                    <input type="date" className='custom-calender-style calender-custom-style'
                      name="date_of_handovers" dateFormat='yy/mm/dd' value={formdataedit.date_of_handovers} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }}/>  
                    {/* <Calendar className='calender-custom-style'
                      name="date_of_handovers" dateFormat='yy/mm/dd' value={formdataedit.date_of_handovers} onChange={(e) => edithandleChange(e)} style={{ width: '100%' }} /> */}
                     
                  </div>

                  <div className='col-md-6'>
                    <br />
                    <label>Name of the Project <span className='error'>*</span></label>
                    <br />
                    <input type='text' required name='project_name' value={formdataedit.project_name} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.project_name}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Department Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="departmentname" value={formdataedit.departmentname} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {deptcomp}
                    </select>
                    <span className='error'>{newErrors.edituser.departmentname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Team Name <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="teamname" value={formdataedit.teamname} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {teamcomp}
                    </select>
                    <span className='error'>{newErrors.edituser.teamname}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>Role <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="roletype" value={formdataedit.roletype} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {rolecomp}
                    </select>
                    <span className='error'>{newErrors.edituser.roletype}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>User Type <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="role" value={formdataedit.role} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      <option value="UL1">Manager</option>
                      <option value="CL1">Normal User</option>
                    </select>
                    <span className='error'>{newErrors.edituser.role}</span>
                  </div>

                  <div className='col-md-3'>
                    <br />
                    <label>project <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="project" value={formdataedit.project} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {projectcomp}
                    </select>
                    <span className='error'>{newErrors.edituser.project}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Aprover <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="approver" value={formdataedit.approver} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {userscomp}
                    </select>
                    <span className='error'>{newErrors.edituser.approver}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Cost Center <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="costcenter" value={formdataedit.costcenter} onChange={(e) => edithandleChange(e)}>
                      <option value="">Select</option>
                      {costcentercomp}
                    </select>
                    <span className='error'>{newErrors.edituser.costcenter}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Employee ID <span className='error'>*</span></label>
                    <br />
                    <input type='number' required name='employeeid' value={formdataedit.employeeid} class="form-control" onChange={(e) => edithandleChange(e)} />
                    <span className='error'>{newErrors.edituser.employeeid}</span>
                  </div>
                  <div className='col-md-3'>
                    <br />
                    <label>Add Permission <span className='error'>*</span></label>
                    <br />
                    <select class="form-control" required name="isadder" value={formdataedit.isadder} onChange={(e) => edithandleChange(e)}>
                      <option value="1">Enabled</option>
                      <option value="0">Disabled</option>
                    </select>
                    <span className='error'>{newErrors.edituser.isadder}</span>
                  </div>
                </div>
                <br />
                <br />

                <div className='row'>
                  <div>
                  {/* onChange={(e)=> subclientpower(e,value.id)} */}
                      <span>
                         {/* {formdataedit.status} */}
                         <ToggleButton style={{background:'orange',color:'white'}} checked={formdataedit.status == 1 ? true : false} 
                         onChange={(e) => updateuserstatus(e,formdataedit.id)}
                         onLabel="Deactivate" offLabel="Activate" onIcon="" offIcon="fa fa-cancel" className="w-8rem"/>
                      </span>
                    <div className='pull-right'>
                      <span>
                        <Button type="submit" label="Save" icon="pi pi-check" severity="success" rounded />
                      </span>

                      <span>
                        <Button type="button" label="Close" severity="danger" onClick={() => setusereditdialog(false)} rounded />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Dialog>
          <div className="col-md-12">
            {
              !isloaded ? loader.Loadermd() : (<table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">User Id</th>
                    <th scope="col">User Name</th>
                    <th scope="col">Project</th>
                    <th scope="col">Type</th>
                    <th scope="col">Verified On</th>
                    <th scope="col">Status</th>
                    <th scope="col">Reset</th>
                    <th scope="col">Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {users}
                </tbody>
              </table>)
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default Users;